import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { fetchFileMetadata, getSecureTeam, getSecureStatus, checkteamCreator, batchProgress, copyFile, saveAsFile } from '@kso/ui/lib/request';
import { subFileName, getFileIcon } from '@kso/util';
import Finder from '@kso/ui/lib/Finder';
import '@kso/ui/lib/Finder/style.css';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import { t } from '@kso/ui/lib/config/locale';

var FileCopy = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', [_c('k-finder', {
      attrs: {
        "okText": _vm.saveas ? _vm.lang_txt0 : _vm.lang_txt1,
        "committing": _vm.processing,
        "isSelectFile": false,
        "limitedCompany": _vm.limitedCompany,
        "limitedTabs": _vm.limitedTabs,
        "initSource": _vm.initSource
      },
      on: {
        "onClose": _vm.onClose,
        "onSubmit": _vm.onSubmit
      }
    })], 1);
  },
  staticRenderFns: [],
  name: 'KFileCopy',
  components: {
    KFinder: Finder
  },
  props: {
    id: {
      type: Array,
      required: true
    },
    saveas: {
      type: Boolean,
      "default": false
    },
    limitedCompany: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    secureTeam: {
      type: Boolean,
      required: false
    },
    hasFolder: {
      type: Boolean,
      required: false
    },
    limitedTabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    initSource: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      lang_txt0: t('logic.FileCopy.txt0'),
      lang_txt1: t('logic.FileCopy.txt1'),
      metadata: {},
      processing: false
    };
  },
  computed: {
    fname: function fname() {
      if (this.id.length > 1) {
        return '';
      }
      return this.metadata.fname || '';
    },
    title: function title() {
      if (this.id.length > 1) {
        return "".concat(t('logic.FileCopy.txt2')).concat(this.id.length).concat(t('logic.FileCopy.txt3'));
      }
      return this.fname && subFileName(this.fname) || '';
    },
    icon: function icon() {
      return this.fname && getFileIcon(this.fname, this.metadata.ftype) || '';
    }
  },
  beforeCreate: function beforeCreate() {
    this.abort = function () {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$fetchFileMetad, fileinfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchFileMetadata(_this.id[0]);
          case 2:
            _yield$fetchFileMetad = _context.sent;
            fileinfo = _yield$fetchFileMetad.fileinfo;
            _this.metadata = fileinfo;
            _this.$emit('propsChange', {});
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.abort();
  },
  methods: {
    onClose: function onClose() {
      this.$emit('close');
    },
    onSubmit: function onSubmit(formdata) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var sameTeam, needSecure, _yield$getSecureStatu, data, _yield$getSecureTeam, _data, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.saveas) {
                _context2.next = 3;
                break;
              }
              _this2.onCopy(formdata);
              return _context2.abrupt("return");
            case 3:
              sameTeam = formdata.groupid === _this2.metadata.groupid;
              needSecure = false;
              if (!(_this2.secureTeam && !sameTeam)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 8;
              return getSecureStatus(_this2.metadata.groupid, _this2.id);
            case 8:
              _yield$getSecureStatu = _context2.sent;
              data = _yield$getSecureStatu.data;
              needSecure = data.length > 0;
            case 11:
              if (!(!sameTeam && !needSecure)) {
                _context2.next = 23;
                break;
              }
              _context2.prev = 12;
              _context2.next = 15;
              return getSecureTeam(_this2.metadata.groupid);
            case 15:
              _yield$getSecureTeam = _context2.sent;
              _data = _yield$getSecureTeam.data;
              if (_data && _data.init_decode_status === 0) {
                needSecure = true;
              }
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](12);
              console.log(_context2.t0);
            case 23:
              if (_this2.secureTeam && _this2.hasFolder && !sameTeam) {
                needSecure = true;
              }
              if (!(!sameTeam && needSecure)) {
                _context2.next = 35;
                break;
              }
              _context2.prev = 25;
              _context2.next = 28;
              return getSecureTeam(formdata.groupid);
            case 28:
              res = _context2.sent;
              if (res.data && res.data.secure_switch === 1) {
                needSecure = false;
              }
              _context2.next = 35;
              break;
            case 32:
              _context2.prev = 32;
              _context2.t1 = _context2["catch"](25);
              console.log(_context2.t1);
            case 35:
              needSecure ? _this2.onDecrypt(formdata) : _this2.onCopy(formdata);
            case 36:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[12, 20], [25, 32]]);
      }))();
    },
    onDecrypt: function onDecrypt(formdata) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res, options;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return checkteamCreator(_this3.metadata.groupid);
            case 2:
              res = _context3.sent;
              options = {
                title: '复制',
                onSecureCallback: function onSecureCallback(decrypt) {
                  _this3.onCopy(formdata, decrypt);
                },
                isTeamCreator: res.result,
                actionType: 'copy'
              };
              _this3.$emit('change', 'KSecureTeamTips', options);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onCopy: function onCopy(formdata) {
      var _arguments = arguments,
        _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var decrypt, id, groupid, created, _formdata_, _ref, data, progress, _ref2, xResponse, _ref3, _ref3$data, _data2, _ref4, faillist, _e$response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              decrypt = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              id = formdata.id, groupid = formdata.groupid;
              created = [];
              if (!_this4.processing) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return");
            case 5:
              _this4.processing = true;
              _context4.prev = 6;
              _formdata_ = {
                fileids: _this4.id,
                groupid: _this4.metadata.groupid,
                parentid: _this4.metadata.parentid,
                target_groupid: groupid,
                target_parentid: id,
                decrypt: decrypt
              };
              if (!_this4.saveas) {
                _context4.next = 14;
                break;
              }
              _context4.next = 11;
              return saveAsFile(_formdata_);
            case 11:
              _context4.t0 = _context4.sent;
              _context4.next = 17;
              break;
            case 14:
              _context4.next = 16;
              return copyFile(_formdata_);
            case 16:
              _context4.t0 = _context4.sent;
            case 17:
              _ref = _context4.t0;
              data = _ref.data;
              _context4.next = 21;
              return batchProgress(_this4.metadata.groupid, {
                groupid: groupid,
                parentid: id,
                taskid: data.taskid,
                decrypt: decrypt,
                desc: 'copyFile',
                cancel: function cancel(c) {
                  _this4.abort = c;
                }
              });
            case 21:
              progress = _context4.sent;
              if (progress) {
                created = progress.fileids || [];
              } else {
                created = created = data.fileids || data.fileid && [data.fileid] || [];
              }
              _this4.$emit('close', 'ok', {
                taskid: data.taskid,
                formdata: _formdata_,
                created: created,
                groupid: groupid,
                parentid: id,
                fileid: _this4.saveas ? data && data.fileid : ''
              });
              Message.success(t('logic.FileCopy.txt4'));
              _context4.next = 34;
              break;
            case 27:
              _context4.prev = 27;
              _context4.t1 = _context4["catch"](6);
              _ref2 = _context4.t1 || {}, xResponse = _ref2.xResponse;
              _ref3 = xResponse || {}, _ref3$data = _ref3.data, _data2 = _ref3$data === void 0 ? {} : _ref3$data;
              _ref4 = _data2 || {}, faillist = _ref4.faillist;
              if (faillist && faillist.length) {
                Message.error({
                  type: 'error',
                  message: _context4.t1 === null || _context4.t1 === void 0 || (_e$response = _context4.t1.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.faillist) === null || _e$response === void 0 || (_e$response = _e$response[0]) === null || _e$response === void 0 ? void 0 : _e$response.msg
                });
              } else {
                Message.error({
                  type: 'error',
                  message: _data2.msg
                });
              }
              _this4.processing = false;
            case 34:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 27]]);
      }))();
    }
  }
};

FileCopy.install = function (Vue) {
  Vue.component(FileCopy.name, FileCopy);
};

export { FileCopy as default };
